import { Button } from "./ui/button";
import heroBackgroundImage from "../assets/hero5.jpg";
import heroBackgroundImageSmall from "../assets/hero1.jpg";
import heroBackgroundImageSmall2 from "../assets/hero2.jpg";
import heroBackgroundImageMed from "../assets/hero4.jpg";

export function Hero() {
  return (
    <section
      id="home"
      className="min-h-screen flex items-center justify-end relative overflow-hidden"
    >
      {/* Background Image - Responsive with picture element */}
      <div className="absolute inset-0 overflow-x-visible medi:ml-[-100px] xs:ml-[-400px] xxs:ml-[-480px] xxxs:ml-[-550px]">
        <picture>
          {/* Large screens (1500px and up) */}
          <source media="(min-width: 1600px)" srcSet={heroBackgroundImage} />
          {/* Medium screens (1350px - 1499px) */}
          <source media="(min-width: 1350px)" srcSet={heroBackgroundImageMed} />
          {/* Small screens (768px - 1349px) */}
          <source
            media="(min-width: 768px)"
            srcSet={heroBackgroundImageSmall}
          />
          {/* Very small screens (536px - 767px) */}
          <source
            media="(min-width: 536px)"
            srcSet={heroBackgroundImageSmall2}
          />
          {/* Extra small screens (<536px) */}
          <img
            src={heroBackgroundImageSmall}
            alt="YOGIVITY background"
            className="overflow-x-visible w-full h-full object-cover xxxs:object-none object-left transform scale-x-[-1]
              medi:ml-[100px]      /* 100px right at ≤879px */
              xs:ml-[400px]        /* 200px right at ≤767px */
              xxs:ml-[480px]        /* 200px right at ≤575px */
              xxxs:ml-[550px]        /* 200px right at ≤535px */
              max-w-[calc(100%+200px)]" /* Prevents cropping */
            style={{ objectPosition: "left center", position: "relative" }}
          />
        </picture>

        {/* Overlay for better text contrast */}
        <div className="absolute inset-0 bg-black/30"></div>
        {/* Strong gradient overlay from right to ensure text readability */}
        <div className="absolute inset-0 bg-gradient-to-l from-black/80 via-black/50 to-transparent"></div>
      </div>

      <div className="max-w-7xl mx-auto px-8 py-32 relative z-10 w-full">
        <div className="max-w-2xl ml-auto xxxs:mx-auto space-y-8 mr-12 xxxs:mr-0">
          <div className="space-y-6">
            <h1 className="text-5xl md:text-6xl lg:text-7xl tracking-tight text-right xxxs:text-center">
              <span className="block text-white drop-shadow-lg">
                Fedezd fel a
              </span>
              <span className="block text-primary drop-shadow-lg">
                TE utadat
              </span>
              <span className="block text-white drop-shadow-lg">
                a hosszú élethez
              </span>
              <span className="block text-white drop-shadow-lg">
                és a vitalitáshoz
              </span>
            </h1>

            <div className="space-y-4 max-w-xl ml-auto xxxs:mx-auto">
              <p className="text-lg text-white drop-shadow-md leading-relaxed text-right xxxs:text-center">
                Szia, örülök, hogy itt vagy! A YOGIVITY nevet két szó ihlette:{" "}
                <em>longevity</em> – azaz hosszú, minőségi élet – és{" "}
                <em>yogi</em>, a jógát gyakorló ember. Ez a program nem egy
                gyors megoldás, hanem egy mély, átgondolt folyamat: abban
                segítek, hogy az idő múlása ne ijesztő, hanem méltóságteljes és
                energikus legyen.
              </p>
              <p className="text-lg text-white drop-shadow-md leading-relaxed text-right xxxs:text-center">
                Együtt olyan életmódot alakítunk ki, amit nem pár hétig, hanem{" "}
                <strong>egész életedben</strong> örömmel és könnyedén tudsz
                követni, akkor is, ha nagyon elfoglalt vagy. Személyre szabott
                tanácsadással, tudatos mozgással, táplálkozási útmutatással és a
                belső egyensúly megtalálásával támogatlak ebben.
              </p>
              <p className="text-lg text-white drop-shadow-md leading-relaxed text-right xxxs:text-center">
                A YOGIVITY alapja a{" "}
                <strong>türelem, az egyszerűség és a fenntarthatóság</strong> –
                mert a valódi változás nem a gyorsaságról szól, hanem arról,
                hogy egész életedben fennmarad.
              </p>
            </div>
          </div>

          <div className="flex justify-end xxxs:justify-center">
            <Button
              size="lg"
              className="bg-primary text-primary-foreground px-10 py-5 text-xl shadow-d
              min-w-fit xxxs:w-[max(calc(100%-20px),fit-content)] xxxs:px-4 hover:bg-[#6d5a44] active:bg-[#5a4a38] transition-colors duration-200 hover:scale-[1.02] active:scale-[0.98] hover:shadow-lg hover:shadow-primary/30 "
               onClick={() => document.getElementById('book-appointment')?.scrollIntoView({ behavior: 'smooth', block: 'center' })}
            >
              Foglalj egy ingyenes beszélgetést
            </Button>
          </div>

          <div className="max-w-2xl ml-auto h-[120px]">
          </div>
        </div>
      </div>
    </section>
  );
}
